export default {"src":"/_next/static/media/quote.9f63dbb6.svg","height":60,"width":74};